import React from 'react';
import './Header.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { useMediaQuery } from 'react-responsive';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function Header({ strapiData, setShowEbookModal }) {

    const isTab = useMediaQuery({ maxWidth: 1023 }); // Breakpoint pour LG

    if (!strapiData) return null;

    const handleButtonClick = () => {
        setShowEbookModal(true);
    };

    return (
        <section className="ebook-header">
            <div className="picture-container">
                <StrapiImageWithSkeleton
                    picture={strapiData.Photo}
                    loading="lazy"
                />
                <div className="ebook-header__content">
                    {
                        isTab ?
                            <div className="ebook-header__text" dangerouslySetInnerHTML={safeHtml(strapiData.TexteMobile)} />

                            :
                            <div className="ebook-header__text" dangerouslySetInnerHTML={safeHtml(strapiData.Texte)} />
                    }
                </div>
            </div>
            <div className="button-container">
                <CustomBtn
                    type={'action'}
                    title={strapiData.TexteBouton}
                    on_click={handleButtonClick}
                    bkg_color={'transparent'}
                    bkg_color_hover={'#EEE6DB'}
                    text_color={'#EEE6DB'}
                    text_color_hover={'#361215'}
                    border_color={'#EEE6DB'}
                    border_color_hover={'#EEE6DB'}
                    font_family={"Playfair Display"}
                    font_size={'28px'}
                    font_weight={'normal'}
                    border_radius={'3px'}
                    width={'430px'}
                    height={'55px'}
                    margin={'10px 0'}
                    letter_spacing={'2px'}
                />
            </div>
        </section>
    );
}
